
export default {
  no_reversible_msg: 'Esta acción es irreversible',
  input_cancel: 'Cancelar',
  input_save: 'Guardar'
}
